//виджет выбора файла для загрузки на странице push.html

if ($("#vue-file").length) {
    new Vue({
        el: "#vue-file",
        data: {
            fileName: "Загрузите изображение",
        },
        methods: {
            fileChange(input) {
                // console.log(input.files[0].name);
                this.fileName = input.files[0].name;
            }
        }
    });
};




// WEBPACK FOOTER //
// ./vue/file.js